import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PAYMENT_THRESHOLD, STATIC_ROOT } from '../constants';

import { convertHtmlToReactDomWithParams } from '../utils/htmlUtils';

import SvgComponent from './SvgComponent';
import LocalizedNavLink from './router/LocalizedNavLink';

import './StepsComponent.scss';

class StepsComponent extends React.Component {
    getSteps = () => {
        const {
            i18nOnline,
            i18nOffline,
            i18nEbon,
            BRAND_NAME,
            BRAND_NAME_ALT,
            isOffline,
            isEbon
        } = this.props;

        if (isOffline) {
            return (
                <React.Fragment>
                    <div className="cmt-ca-marche-bloc">
                        <SvgComponent src={`${STATIC_ROOT}/ccm-1.svg`} width="72" height="72" />
                        <div className="texte">
                            <p>
                                {convertHtmlToReactDomWithParams(i18nOffline.STEP1, BRAND_NAME_ALT)}
                            </p>
                        </div>
                    </div>
                    <div className="cmt-ca-marche-bloc">
                        <SvgComponent src={`${STATIC_ROOT}/ccm-2.svg`} width="72" height="72" />
                        <div className="texte">
                            <p>
                                {convertHtmlToReactDomWithParams(i18nOffline.STEP2_1)}
                                <LocalizedNavLink to="/envoi-ticket" title={i18nOffline.STEP2_2}>
                                    {i18nOffline.STEP2_2}
                                </LocalizedNavLink>
                                {i18nOffline.STEP2_3}
                            </p>
                        </div>
                    </div>
                    <div className="cmt-ca-marche-bloc">
                        <SvgComponent src={`${STATIC_ROOT}/ccm-3.svg`} width="72" height="72" />
                        <div className="texte">
                            <p>
                                {convertHtmlToReactDomWithParams(
                                    i18nOffline.STEP3,
                                    BRAND_NAME_ALT,
                                    PAYMENT_THRESHOLD
                                )}
                            </p>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else if (isEbon) {
            return (
                <React.Fragment>
                    <div className="cmt-ca-marche-bloc">
                        <SvgComponent src={`${STATIC_ROOT}/ccm-1.svg`} width="72" height="72" />
                        <div className="texte">
                            <p>{convertHtmlToReactDomWithParams(i18nEbon.STEP1)}</p>
                        </div>
                    </div>
                    <div className="cmt-ca-marche-bloc">
                        <SvgComponent src={`${STATIC_ROOT}/ccm-2.svg`} width="72" height="72" />
                        <div className="texte">
                            <p>{convertHtmlToReactDomWithParams(i18nEbon.STEP2, BRAND_NAME)}</p>
                        </div>
                    </div>
                    <div className="cmt-ca-marche-bloc">
                        <SvgComponent src={`${STATIC_ROOT}/ccm-3.svg`} width="72" height="72" />
                        <div className="texte">
                            <p>{convertHtmlToReactDomWithParams(i18nEbon.STEP3)}</p>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <div className="cmt-ca-marche-bloc">
                        <SvgComponent src={`${STATIC_ROOT}/ccm-1.svg`} width="72" height="72" />
                        <div className="texte">
                            <p>
                                {convertHtmlToReactDomWithParams(i18nOnline.STEP1, BRAND_NAME_ALT)}
                            </p>
                        </div>
                    </div>
                    <div className="cmt-ca-marche-bloc">
                        <SvgComponent src={`${STATIC_ROOT}/ccm-2.svg`} width="72" height="72" />
                        <div className="texte">
                            <p>
                                {convertHtmlToReactDomWithParams(i18nOnline.STEP2, BRAND_NAME_ALT)}
                            </p>
                        </div>
                    </div>
                    <div className="cmt-ca-marche-bloc">
                        <SvgComponent src={`${STATIC_ROOT}/ccm-3.svg`} width="72" height="72" />
                        <div className="texte">
                            <p>
                                {convertHtmlToReactDomWithParams(
                                    i18nOnline.STEP3,
                                    BRAND_NAME_ALT,
                                    PAYMENT_THRESHOLD
                                )}
                            </p>
                        </div>
                    </div>
                </React.Fragment>
            );
        }
    };

    render() {
        return (
            <section className="steps">
                <div className="wrapper">{this.getSteps()}</div>
            </section>
        );
    }
}

StepsComponent.propTypes = {
    isOffline: PropTypes.bool
};

const mapStoreToProps = state => ({
    i18nOnline: state.i18n.feature.aide.HOW_IT_WORKS.ONLINE,
    i18nOffline: state.i18n.feature.aide.HOW_IT_WORKS.OFFLINE,
    i18nEbon: state.i18n.feature.aide.HOW_IT_WORKS.EBON,
    BRAND_NAME: state.i18n.common.BRAND_NAME,
    BRAND_NAME_ALT: state.i18n.common.BRAND_NAME_ALT
});

export default connect(mapStoreToProps)(StepsComponent);



// WEBPACK FOOTER //
// ./src/components/StepsComponent.js